import React from 'react';
// import classNames from 'classnames';

interface Props {
  title: string;
  text: Array<string | undefined>;
}

export const TextBlock = (props: Props) => {
  const {
    title,
    text,
  } = props;

  return (
    <div className="TextBlock">
      <h3>{title}</h3>

      {text.map((textItem) => {
        if (!textItem) {
          return null;
        }

        return (
          <p key={textItem}>{textItem}</p>
        );
      })}
    </div>
  );
};
